import { render, staticRenderFns } from "./development-history.vue?vue&type=template&id=46f4d930&scoped=true&"
import script from "./development-history.vue?vue&type=script&lang=js&"
export * from "./development-history.vue?vue&type=script&lang=js&"
import style0 from "./development-history.vue?vue&type=style&index=0&id=46f4d930&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f4d930",
  null
  
)

export default component.exports